<template>
    <v-container>
        <v-card>
            <v-card-title>{{text.loginTitle}}</v-card-title>
            <v-card-text>
                <v-text-field id="login_UserId" v-model="userId" :label="text.userId"></v-text-field>
                <v-text-field id="login_Password" v-model="password" :type="showP?'text':'password'" :label="text.password" @keyup.enter="login">
                    <template v-slot:append>
                        <v-icon tabindex="-1" @click="showP = !showP" v-show="showP">mdi-eye</v-icon>
                        <v-icon tabindex="-1" @click="showP = !showP" v-show="!showP">mdi-eye-off</v-icon>
                    </template>
                </v-text-field>
                <v-text-field autocomplete="off" id="login_otp" v-model="otpToken" :label="text.otpCode" @keyup.enter="login"></v-text-field>
                <div class="d-flex flex-column">
                    <v-alert v-show="authfail" dense type="error">{{text.authFail}}</v-alert>
                    <v-alert v-show="authLock" dense type="warning">{{text.authLock}}<br>{{text.authUnLock}}</v-alert>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-btn :disabled="disLoginBtn" v-on:click="login">{{text.loginTitle}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script lang="ts">
    import Vue from 'vue';
    import lang from "../lang";
    let text = new lang(0);
    import {apiRequest} from "../lib/api"
    import * as comm from '../common';
    import {indexDb} from "../lib/indexDbStore";
    const db = new indexDb();

    export default Vue.extend({
        components:{},
        data: () => ({
            text : text.Text,
            userId :"",
            password:"",
            otpToken:"",
            authfail:false,
            disLoginBtn:false,
            authLock:false,
            showP:false,
            api:null as null|{connection:boolean,apiRequest:null|apiRequest},
        }),
        mounted() {
            this.api = this.$store.state.apiSaver;
        },
        methods:{
            reset(){
                //@ts-ignore
                Object.assign(this.$data,this.$options.data());
            },
            async login(){
                this.disLoginBtn = true;
                this.authfail = false;
                this.authLock = false;
                this.showP = false;
                if(this.api && this.api.connection && this.api.apiRequest){
                    const authResult = await this.api.apiRequest.request.auth({"userid":this.userId,"password":this.password,"otpToken":this.otpToken});
                    this.disLoginBtn = false;
                    if(authResult.statusCode === 200){
                        if(authResult.data.status){
                            const sessionData = this.api.apiRequest.getSessionData();
                            if(sessionData){
                                this.reset();
                                this.$store.commit("setUser",{
                                    "userId":authResult.data.userid,
                                    "userName":authResult.data.username,
                                    "administrator":authResult.data.administrator,
                                    "totp":authResult.data.totp,
                                    "lastLogin":authResult.data.lastLogin?new Date(authResult.data.lastLogin):null,
                                    "tpdata":authResult.data.tpdata,
                                    "flags":authResult.data.flags,
                                    "proxyUserKey":authResult.data.proxyUserKey,
                                });
                                this.$emit("parentCall","authScces");
                            }else{
                                comm.ApiErrorMessege(this,{"httpStatus":1,"code":1});
                            }
                        }else{
                            this.authfail = true;
                            if(authResult.data.lock){
                                this.authLock = true;
                            }
                        }
                    }
                }else{
                    comm.ApiErrorMessege(this,{"httpStatus":1,"code":1});
                }
            },
        }
    });
</script>